'use client';
import cn from 'classnames';
import Image from 'next/image';
import Button from '@/components/common/Button/Button';
import Link from '@/components/common/Link/Link';
import Text from '@/components/common/Text/Text';

import './HighlightCardMini.style.scss';
import { HighlightCardMiniProps } from '@/types/Builder';
import AspectRatioImage from '@/components/common/AspectRatioImage/AspectRatioImage';

function HighlightCardMini(props: HighlightCardMiniProps) {
  const {
    className = '',
    headline,
    description,
    ctaText,
    ctaLink,
    image
  } = props;

  return (
    <div className={cn('HighlightCardMini', className)}>
      <AspectRatioImage
        className='HighlightCardMini-image'
        src={image.image}
        alt={image.imageAltText}
        height={image.imageHeight}
        width={image.imageWidth}
      />
      <div className='HighlightCardMini-content'>
        <div className='HighlightCardMini-copy'>
          <Text
            className='HighlightCardMini-title'
            variant='title-m'
            italic
          >
            {headline}
          </Text>
          <Text
            className='HighlightCardMini-description'
            variant='text-s'
          >
            {description}
          </Text>
        </div>

        {ctaText && ctaLink && (
          <div className='HighlightCardMini-cta'>
            <Link href={ctaLink}>
              <Button
                variant='underline'
                size='small'
              >
                {ctaText}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default HighlightCardMini;
